export const state = () => ({
  inventoryItemsObj: {
    subscriptions: [],
    products: []
  }
});

export const mutations = {
  setInventoryItemsObj(state, inventoryItemsObj) {
    state.inventoryItemsObj = inventoryItemsObj;
  }
};

export const getters = {
  inventoryItemsObj: state => state.inventoryItemsObj
};

export default {
  state,
  mutations,
  getters
};
